// Check if APP_DEBUG is false and APP_URL does not contain 'test' or 'localhost'
export default function isProduction() {
    const isDebug = process.env.APP_DEBUG == 'true';

    // On the server there is no location
    const appUrl =
        process.env.APP_URL ??
        (typeof location !== 'undefined' ? location.origin : '');

    return (
        !isDebug && !appUrl.includes('test') && !appUrl.includes('localhost')
    );
}
